import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import Paper from "../../../../componentsv2/Paper";
import Button from "../../../../componentsv2/Button";
import { Input } from "../../../../componentsv2/Input";
import GridItem from "../../../../componentsv2/GridItem";
import GridContainer from "../../../../componentsv2/GridContainer";
import SelectDeGenero from "../../components/SelectDeGenero";
import SelectSimNao from "../../components/SelectSimNao";
import DataPickerAtualizado from "../../../../components/DataPickerAtualizado";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSnackbar } from "notistack";

import { api } from "../../../../services/Api";
import useUser from "../../../../hooks/useUser";
import formatDateBD from "../../../../utils/formatarDataBD";
import Container from "../../../../componentsv2/Container";
import Header from "../../../../components/Header";

export default function EditarCliente() {
  const [nomeCliente, setNomeCliente] = useState("");
  const [rg, setRg] = useState("");
  const [cpf, setCpf] = useState("");
  const [dataExpedicao, setDataExpedicao] = useState("");
  const [orgaoExpedidor, setOrgaoExpedidor] = useState("");
  const [genero, setGenero] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [peso, setPeso] = useState("");
  const [altura, setAltura] = useState("");
  const [gestante, setGestante] = useState("");
  const [telefone, setTelefone] = useState("");
  const [celular, setCelular] = useState("");
  // const [email, setEmail] = useState("");
  const [nomeMae, setNomeMae] = useState("");
  const [medicacao, setMedicacao] = useState("");
  const [indicacao, setIndicacao] = useState("");
  const [endereco, setEndereco] = useState("");
  const [numeroEndereco, setNumeroEndereco] = useState("");
  const [cidade, setCidade] = useState("");
  const [bairro, setBairro] = useState("");
  const [estado, setEstado] = useState("");
  const [cep, setCep] = useState("");
  const [complemento, setComplemento] = useState("");

  const usuario = useUser();
  const history = useHistory();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async () => {
    try {
      const data = {
        atendente: usuario,
        nome: nomeCliente,
        rg,
        cpf,
        mae: nomeMae,
        dataNascimento: formatDateBD(dataNascimento),
        sexo: genero,
        endereco,
        enderecoNumero: numeroEndereco,
        bairro,
        cidade,
        celular,
        telefone,
        peso,
        altura,
        gestante,
        medicacao,
        indicacao,
        cep,
        complemento,
        estado,
        dataExpedicao: formatDateBD(dataExpedicao),
        orgaoExpedidor,
      };
      await api.put(`/v2/controleDna/cliente/${location.state.row.id}`, data);
      history.push("/GestaoDeClientes");
      enqueueSnackbar("Alterações salvas com sucesso!", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Erro! Não foi possível alterar os dados do cliente.", {
        variant: "error",
      });
    }
  };

  const pegarDadosCliente = async () => {
    if (location.state?.row) {
      try {
        const {
          data: { data },
        } = await api.get(`/v2/controleDna/cliente/${location.state.row.id}`);
        setNomeCliente(data.nome);
        setRg(data.rg);
        setCpf(data.cpf);
        setDataExpedicao(data.dataExpedicao);
        setOrgaoExpedidor(data.orgaoExpedidor);
        setGenero(data.sexo);
        setDataNascimento(data.dataNascimento);
        setPeso(data.peso);
        setAltura(data.altura);
        setGestante(data.gestante);
        setTelefone(data.telefone);
        setCelular(data.celular);
        setNomeMae(data.mae);
        setMedicacao(data.medicacao);
        setIndicacao(data.indicacao);
        setEndereco(data.endereco);
        setNumeroEndereco(data.enderecoNumero);
        setCidade(data.cidade);
        setBairro(data.bairro);
        setEstado(data.estado);
        setCep(data.cep);
        setComplemento(data.complemento);
      } catch (error) {
        enqueueSnackbar("Erro! Não foi possível buscar os dados do cliente.", {
          variant: "error",
        });
      }
    } else {
      history.push("/GestaoDeClientes");
    }
  };

  useEffect(() => {
    pegarDadosCliente();
    // eslint-disable-next-line
  }, [location.state?.row]);

  return (
    <>
    <Header  titulo="Editar Informações Do Cliente"/>
    <Container>
      <Button onClick={() => history.push({ pathname: "/GestaoDeClientes" })}>
        <ArrowBackIcon style={{ color: "#003399" }} />
      </Button>
      <Paper style={{ padding: "40px", marginTop: "10px" }} elevation={2}>
        <form onSubmit={handleSubmit}>
          <GridContainer xs={12} spacing={2}>
            <GridItem xs={6}>
              <Input
                onChange={e => {
                  setNomeCliente(e.target.value);
                }}
                value={nomeCliente}
                required
                fullWidth
                label="Nome"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={3}>
              <Input
                onChange={e => {
                  setRg(e.target.value);
                }}
                value={rg}
                required
                fullWidth
                label="RG"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={3}>
              <Input
                onChange={e => {
                  setCpf(e.target.value);
                }}
                value={cpf}
                required
                fullWidth
                label="CPF"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={2}>
              <DataPickerAtualizado
                data={dataExpedicao}
                setData={setDataExpedicao}
                required
                variant="standard"
                labelName="Data de Expedição"
              />
            </GridItem>

            <GridItem xs={4}>
              <Input
                onChange={e => {
                  setOrgaoExpedidor(e.target.value);
                }}
                value={orgaoExpedidor}
                fullWidth
                label="Orgão Expedidor"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={3}>
              <SelectDeGenero
                onChange={e => {
                  setGenero(e.target.value);
                }}
                value={genero}
              />
            </GridItem>

            <GridItem xs={3}>
              <DataPickerAtualizado
                data={dataNascimento}
                setData={setDataNascimento}
                required
                variant="standard"
                labelName="Data de Nascimento"
              />
            </GridItem>

            <GridItem xs={2}>
              <Input
                onChange={e => {
                  setPeso(e.target.value);
                }}
                value={peso}
                fullWidth
                label="Peso"
                type="number"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={2}>
              <Input
                onChange={e => {
                  setAltura(e.target.value);
                }}
                value={altura}
                fullWidth
                label="Altura"
                type="number"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={2}>
              <SelectSimNao
                onChange={e => {
                  setGestante(e.target.value);
                }}
                value={gestante}
              />
            </GridItem>

            <GridItem xs={3}>
              <Input
                onChange={e => {
                  setTelefone(e.target.value);
                }}
                value={telefone}
                fullWidth
                label="Telefone"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={3}>
              <Input
                onChange={e => {
                  setCelular(e.target.value);
                }}
                value={celular}
                fullWidth
                label="Celular"
                type="text"
                variant="standard"
              />
            </GridItem>

            {/* <GridItem xs={3}>
              <Input
                onChange={e => {
                  setEmail(e.target.value);
                }}
                value={email}
                fullWidth
                label="E-mail"
                type="text"
                variant="standard"
              />
            </GridItem> */}

            <GridItem xs={6}>
              <Input
                onChange={e => {
                  setNomeMae(e.target.value);
                }}
                value={nomeMae}
                fullWidth
                label="Mãe"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={3}>
              <Input
                onChange={e => {
                  setMedicacao(e.target.value);
                }}
                value={medicacao}
                fullWidth
                label="Medicação"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={4}>
              <Input
                onChange={e => {
                  setIndicacao(e.target.value);
                }}
                value={indicacao}
                fullWidth
                label="Indicação"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={8}>
              <Input
                onChange={e => {
                  setEndereco(e.target.value);
                }}
                value={endereco}
                required
                fullWidth
                label="Endereço"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={4}>
              <Input
                onChange={e => {
                  setNumeroEndereco(e.target.value);
                }}
                value={numeroEndereco}
                fullWidth
                label="Nº Endereço"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={3}>
              <Input
                onChange={e => {
                  setCidade(e.target.value);
                }}
                value={cidade}
                fullWidth
                label="Cidade"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={3}>
              <Input
                onChange={e => {
                  setBairro(e.target.value);
                }}
                value={bairro}
                fullWidth
                label="Bairro"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={3}>
              <Input
                onChange={e => {
                  setEstado(e.target.value);
                }}
                value={estado}
                fullWidth
                label="Estado"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={3}>
              <Input
                onChange={e => {
                  setCep(e.target.value);
                }}
                value={cep}
                fullWidth
                label="CEP"
                type="text"
                variant="standard"
              />
            </GridItem>

            <GridItem xs={12}>
              <Input
                onChange={e => {
                  setComplemento(e.target.value);
                }}
                value={complemento}
                fullWidth
                label="Complemento"
                type="text"
                variant="standard"
              />
            </GridItem>
          </GridContainer>
          <GridItem
            item
            sx={{ marginTop: "30px" }}
            container
            justifyContent="space-between"
            spacing={2}
          >
            <GridItem
              xs={12}
              sx={{ marginTop: "30px" }}
              container
              justifyContent="flex-end"
              spacing={2}
            >
              <GridItem>
                <Button
                  onClick={() => history.push({ pathname: "/GestaoDeClientes" })}
                  color="red"
                  variant="outlined"
                >
                  Cancelar
                </Button>
              </GridItem>
              <GridItem>
                <Button type="submit" color="green" variant="contained">
                  Salvar
                </Button>
              </GridItem>
            </GridItem>
          </GridItem>
        </form>
      </Paper>
      </Container>
      </>
  );
}
